import React, { useEffect, useState } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
// import CarCovid19 from "../element/CarCovid19";
// Contexto
// import dataContext from "../context/User";

// Helper
// import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from "../componentes/Footer";

import "../css/styleAdmin.css";

const HelpDesk = () => {
  const history = useHistory();

  let datos = localStorage.getItem("dataUser");
  datos = JSON.parse(datos);
  console.log(datos);

  if (!datos) {
    history.push("/");
  }
  

  const [user, setUser] = useState(datos.carnet);
  const [correo, setCorreo] = useState(datos.carnet);

  // const dataUser = useContext(dataContext);

  

  // if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
  //   if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1) {
  //     history.push("/");
  //   }
  // }  

  // setUser(datos.carnet)
  // setCorreo(datos.correo)

  useEffect(() => {
    loadMenu();
  }, []);

  // const btnHelpDesk = (e)=>{
  //   e.preventDefault();
  //   console.log('Redirigir a helpdesk');
  // }

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={datos.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={datos.carnet}
            nombre={datos.nombre}
            perfil={datos.perfil}
            carrera={datos.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">HelpDesk</h2>

        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card">
              <div className="card-body text-center">
                <span className="fa fa-desktop display-4 text-primary d-block mb-3" aria-hidden="true"></span>
                <p className="text-muted">
                  Mesa de ayuda para reportar problemas de hardware o software,
                  solicitar servicios o informar incidencias al equipo de IT.
                </p>
                <form action="https://www.esen.edu.sv/ext/helpdesk/index.php" method="post" target="_blank" className="mt-3">
                  <input type="hidden" name="idusr" value={user}/>
                  <input type="hidden" name="usu_pass" value={correo}/>
                  <input type="submit" className="btn btn-primary btn-block" value="Ingresar"/>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpDesk;
